import { useEffect, useState } from "react";
import { getCmsPage, type CmsPage } from "@/api/cms";

export default function PrivacyPolicyPage() {
  const [page, setPage] = useState<CmsPage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCmsPage("privacy-policy")
      .then(setPage)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="wrapper cms-pages">
      {loading ? (
        <div className="flex justify-center items-center min-h-[300px]">
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-primary border-t-transparent" />
        </div>
      ) : error || !page ? (
        <p className="text-center text-muted-foreground py-10">
          Failed to load Privacy Policy. Please try again later.
        </p>
      ) : (
        <>
          <div className="title mb-10 text-center">
            <h1>{page.title || "Privacy Policy"}</h1>
          </div>
          <div dangerouslySetInnerHTML={{ __html: page.content }} />
        </>
      )}
    </div>
  );
}
